<template>
  <f7-searchbar
    ref="searchbar"
    :placeholder="$t(`what_do_you_want_to_learn`)"
    :custom-search="customSearch"
    :disable-button="false"
    :clear-button="false"
    :search-container="searchContainer"
    :search-in="searchIn"
    :value="value"
    @input="debounceSearch"
  >
    <f7-button
      slot="after-inner"
      class="searchbar-button"
      icon-f7="search"
      icon-color="blue"
      icon-size="24"
      @click="handleSearch"
    ></f7-button>
  </f7-searchbar>
</template>

<script>
import { debounce } from 'lodash';

export default {
  name: 'Search',

  props: {
    customSearch: {
      type: Boolean,
      default: false,
    },

    searchContainer: {
      type: String,
      default: '',
    },

    searchIn: {
      type: String,
      default: '',
    },

    val: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      value: '',
    };
  },

  watch: {
    val(newValue) {
      this.value = newValue;
    },
  },

  mounted() {
    this.$f7.views.main.on('routeChange', () => {
      this.$store.commit('course/SET_SEARCH_COURSES', []);
    });
  },

  methods: {
    // onSearch({ query }) {
    //   this.value = query;
    //   this.$emit('on-search', query);
    // },

    handleSearch() {
      this.$emit('on-debounce-search', this.value);
    },

    debounceSearch: debounce(function (e) {
      this.$emit('on-debounce-search', e.target.value);
    }, 500),
  },
};
</script>

<style lang="less">
.searchbar-button.button {
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  z-index: 30;
  padding: 0;
}
</style>
